export default __webpack_public_path__ + "locales/bg/RoomLogoCover.json?hash=99720dea4871db9840512fbad0c9c684";